/**
 * My Students State Types
 *
 * Type definitions for the MyStudents state slice.
 * Database-backed state with real-time Firestore sync,
 * filtered by user's studentIds array.
 */

import type { AugmentedStudent } from 'src/app/domain/student/types/Student.model';

/** Signal state model for the MyStudentsState slice. */
export interface MyStudentsStateModel {
  // === Data ===
  data: AugmentedStudent[];

  // === Status Flags ===
  initialized: boolean;
  loading: boolean;
  error: string | null;

  // === Metadata ===
  lastUpdated: number | null;

  // === Context ===
  activeTeamId: string | null;
  studentIds: string[];
}

/** Configuration required to initialize MyStudentsState for a practitioner's caseload. */
export interface MyStudentsInitConfig {
  activeTeamId: string;
  studentIds: string[];
  enableRealtimeUpdates?: boolean;
  /** Additional teams to load students from and merge into this state (no realtime listener). */
  additionalTeamContexts?: Array<{ teamId: string; studentIds: string[] }>;
}

export const MY_STUDENTS_DEFAULTS: MyStudentsStateModel = {
  data: [],
  initialized: false,
  loading: false,
  error: null,
  lastUpdated: null,
  activeTeamId: null,
  studentIds: [],
};
